import { requireDefined } from '@nutrien/ddc-fe-util';
import type { IConfigCatClient } from 'configcat-common';
import * as configcat from 'configcat-js';
import { useEffect, useRef, useState } from 'react';
import { singletonHook } from 'react-singleton-hook';

import type { FeatureFlags } from '../types/featureFlags';

const init: FeatureFlags = {};
export interface KeyValues {
  settingKey: string;
  settingValue: string;
}

const useFeatureFlagsImplementation = (): FeatureFlags => {
  const [featureFlags, setFeatureFlags] = useState<FeatureFlags>(init);
  const configCatClient = useRef<IConfigCatClient | null>(null);

  const updateFeatureFlags = async () => {
    if (!configCatClient.current) {
      return;
    }
    configCatClient.current.getAllValues((keyValues: KeyValues[]) => {
      const values: FeatureFlags = {};
      keyValues.forEach((keyValue: KeyValues) => {
        values[keyValue.settingKey] = keyValue.settingValue;
      });
      setFeatureFlags(values);
    });
  };

  useEffect(() => {
    const currentConfigCat = configcat.createClientWithAutoPoll(
      requireDefined(import.meta.env.VITE_CONFIGCAT_KEY),
      {
        configChanged: updateFeatureFlags,
      },
    );
    configCatClient.current = currentConfigCat;
    updateFeatureFlags();

    return () => {
      currentConfigCat.dispose();
    };
  }, []);

  return featureFlags;
};

export const useFeatureFlags = singletonHook(init, useFeatureFlagsImplementation);
